export const appstoreApiKeyFormId = 'source-settings-appstore-api-key-form-id';
export const appstoreAppsFormId = 'source-settings-appstore-apps-form-id';

/** Store account apps page size used by the form and detached-apps confirmation flow. */
export const APPSTORE_APPS_LIST_LIMIT = 200;

export const enum AppstoreAccountStepEnum {
    apiKey = 0,
    apps = 1,
}
